import { defineComponent, onMounted } from 'vue';
import DocumentList from '@/layouts/documents-page/document-list/document-list';
import DocumentListHeader from '@/layouts/documents-page/document-list-header/document-list-header';
import { useDocumentList } from '@/hooks/documents/document-list.composables';
import { useDocumentListFilter } from '@/hooks/documents/document-list-filter.composables';
import DocumentFilterList from '@/layouts/documents-page/document-list-filter/document-list-filter';

export default defineComponent({
  name: 'DocumentsPage',
  components: {
    DocumentFilterList,
    DocumentList,
    DocumentListHeader,
  },
  setup() {
    const { loadDocumentList } = useDocumentList();
    const { updateLoadedDictionaries } = useDocumentListFilter();

    const updateDocumentList = async (): Promise<void> => {
      updateLoadedDictionaries();

      await loadDocumentList();
    };

    onMounted(() => {
      updateDocumentList();
    });
  },
});
